import type { IntakesQueryVariables, Intakes_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function restoreIntakes(arr: Array<string>): Intakes_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteIntakes(arr: Array<string>): Intakes_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultIntakeVars: IntakesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }],
  where: {
    _and: [{ is_hps: { _eq: false } }]
  }
};

export const adminIntakeVars: IntakesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }],
  where: {
    _and: [{ is_hps: { _eq: false } }]
  }
};

export const kocIntakeVars: IntakesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }],
  where: {
    _and: [
      {
        _or: [
          { include_koc_timestamp: { _is_null: false } },
          { only_koc_timestamp: { _is_null: false } }
        ]
      },
      { is_hps: { _eq: false } }
    ]
  }
};
export const ecopetrolIntakeVars: IntakesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }],
  where: {
    _and: [
      {
        _or: [
          { include_ecopetrol_timestamp: { _is_null: false } },
          { only_ecopetrol_timestamp: { _is_null: false } }
        ]
      },
      { is_hps: { _eq: false } }
    ]
  }
};
